import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Card = styled(SegmentLayoutComponent)`
  &.ui.segment {
    :first-child {
      margin-top: 30px;
    }
  }
`;

const ContainerBottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;

const TaskName = styled(TextLayoutComponent)`
`;

const FirstName = styled(TextLayoutComponent)`
`;

const VideoLink = styled.a`
`;

export {
  Card,
  ContainerBottom,
  FirstName,
  TaskName,
  VideoLink,
};
